export const SUPPORT_UNREAD_CHANGED_EVENT = 'dentrist:support-unread-changed';

export const notifySupportUnreadChanged = () => {
  window.dispatchEvent(new CustomEvent(SUPPORT_UNREAD_CHANGED_EVENT));
};
